import { iconSize } from "@/components/ui/icon-container";

export const OVERLAP_SHADOW = "-4px 0 8px 0 rgba(0, 0, 0, 0.5)";

export const getOverlapMargin = (size: iconSize) =>
  size === "sm" ? "-ml-[11px]" : "-ml-[8px]";
